// extracted by mini-css-extract-plugin
export var loaderContainer = "Loader-module--loaderContainer--T6tRs";
export var path = "Loader-module--path--sEzyY";
export var dash = "Loader-module--dash--apwjz";
export var reveal = "Loader-module--reveal--LdCWE";
export var hide = "Loader-module--hide---aF52";
export var fadeInUp = "Loader-module--fade-in-up--R3h-x";
export var slideInDown = "Loader-module--slide-in-down--ipNC-";
export var slideInUp = "Loader-module--slide-in-up--u3si9";
export var moveRightToLeft = "Loader-module--move-right-to-left--MIX5u";
export var moveLeftToRight = "Loader-module--move-left-to-right--wAvr1";